export const Q7_SEVEN_SEATER_GROUP_ID = 'q7_seven_seater'

// Q9 G8 Modelle (118 = Q9_G8, 119 = SQ9_G8, 120 = Q9_G8_S_LINE):
// temporär entfällt hier die 5-Sitzer-Auswahl (Code 0), Standard ist 7 Sitze (Code 3).
export const Q9_G8_MODEL_IDS = ['118', '119', '120']

export function isQ9G8Model(carModel) {
  if (Q9_G8_MODEL_IDS.includes(String(carModel))) {
    return true
  }
  // Fallback: auf dem q9_g8 car-select-Screen sind alle Modelle 118/119/120
  return !!document.querySelector('#car-select-screen')?.classList.contains('q9_g8')
}

function getQ7SeatTranslation(key, fallback = '') {
  return window.q7SeatTranslations?.[key] || fallback
}

export function getQ7SeatModalTitle() {
  return getQ7SeatTranslation(
    'modalTitle',
    'Bitte wählen Sie die entsprechende Sitzanzahl aus.'
  )
}

export function getQ7SeatOptions(carModel) {
  const isQ9 = isQ9G8Model(carModel)

  const options = []

  // 5 Sitze (Code 0) entfällt temporär bei den Q9-G8-Modellen (118/119/120)
  if (!isQ9) {
    options.push({
      code: '0',
      label: `${getQ7SeatTranslation('seat5', '5 Sitze')} (5KA)`,
      // Standardauswahl 5 Sitze bei den Q7-G8-Modellen (115/116/117)
      default: true
    })
  }

  options.push({
    code: '1',
    label: `${getQ7SeatTranslation('seat6', '6 Sitze')} (5KI)`
  })

  /*{
    code: '2',
    label: `${getQ7SeatTranslation('seat6CenterConsoleRear', '6 Sitze, Mittelkonsole hinten')} (5KJ)`
  },*/

  options.push({
    code: '3',
    label: `${getQ7SeatTranslation('seat7', '7 Sitze')} (5KL)`,
    // Standardauswahl 7 Sitze bei den Q9-G8-Modellen (118/119/120)
    default: isQ9
  })

  return options
}

export function getQ7SeatLabelByValue(value, carModel) {
  const option = getQ7SeatOptions(carModel).find((entry) => entry.code === String(value))
  return option ? option.label : ''
}